export const formUnmasking = (value: string, type: string): string => {
    if (type === 'postcode') {
        return value.toString().replace('-', '').replace(' ', '');
    }

    return value;
};
